export interface HeadlineProps {
  value: string;
}

export default function Headline(props: HeadlineProps) {
  return (
    <div
      className="flex flex-row items-center w-full"
      data-aos="fade"
      data-aos-duration="1000"
    >
      <hr className="flex-1 bg-gray h-0.5 block"></hr>
      <span className="select-none flex-none text-gray ~text-base/lg font-barlowc font-bold mx-6 whitespace-pre-wrap text-center">
        {props.value}
      </span>
      <hr className="flex-1 bg-gray h-0.5 block"></hr>
    </div>
  );
}
